import {
    Container,
    Text,
    Image,
    Flex,
    Divider,
} from '@chakra-ui/react';
import { useLanguage } from '../i18n/LanguageContext';

const Footer = () => {
    const { isEnglish } = useLanguage();

    return (
        <Container
            maxW={'full'}
            bgColor={'#002c2f'}
            color={'white'}
            py={6}
            direction={{ base: 'column', md: 'row' }}
            spacing={4}
            justify={{ base: 'center', md: 'space-between' }}
            align={{ base: 'center', md: 'center' }}>

            <Flex>
                <Image maxW='25%' src="/logo_new.png" alt='FinTech@NTU logo' mr={5} />
                <Text textAlign={'left'}>
                    {isEnglish ? 'National Taiwan University' : 'National Taiwan University'} <br />
                    {isEnglish ? 'Fintech Research Center' : '國立臺灣大學金融科技研究中心'}
                </Text>
            </Flex>
            <Divider mt={3} />
            <Flex justifyContent={'space-between'} color={'gray'} fontStyle={'italic'} fontSize={15}>
                <Text textAlign="left">
                    {isEnglish
                        ? 'Tel: +886-2-3366-4888 ext. 542  •  Room 542, Department of Computer Science and Information Engineering, No. 1, Sec. 4, Roosevelt Rd., Taipei 10617, Taiwan'
                        : 'Tel: (02)3366-4888 #542  台北市羅斯福路四段一號 台灣大學資訊工程學系542室'}
                </Text>
                <Text>© 2022 Chakra Templates. All rights reserved</Text>
            </Flex>

        </Container>
    )

}
export default Footer;
